import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  structuredData?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = 'https://www.69shipin.com/',
  ogTitle,
  ogDescription,
  ogType = 'website',
  structuredData,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setPropertyMeta = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    setPropertyMeta('og:title', ogTitle || title);
    setPropertyMeta('og:description', ogDescription || description);
    setPropertyMeta('og:type', ogType);
    setPropertyMeta('og:url', canonicalUrl);

    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);

    if (structuredData) {
      let scriptEl = document.querySelector('#structured-data');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('id', 'structured-data');
        scriptEl.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(structuredData, null, 2);
    }

    return () => {
      const sd = document.querySelector('#structured-data');
      if (sd) sd.remove();
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, structuredData]);

  return null;
}